<template>
    <div style="display: flex">
        <v-slider
                v-if="options.fixedLimits"
                :value="value"
                :max="options.max"
                :min="options.min"
                :step="options.step || 0.01"
                hide-details
                @mousedown="stopImmediatePropagation"
                hint="Test"
                persistent-hint
                thumb-label
                thumb-size="24"
                class="align-center"
                style="width: 100%"
                @change="update"
        >
            <template v-slot:append>
                <v-text-field
                        :value="value"
                        class="center-text mt-0 pt-0"
                        hide-details
                        single-line
                        type="number"
                        style="width: 40px"
                        @change="update"
                ></v-text-field>
            </template>
        </v-slider>
        <v-slider
                v-else
                :value="value"
                :max="options.max > options.min ? options.max - options.min : 0"
                :min="options.step || 0.01"
                :step="options.step || 0.01"
                hide-details
                hint="Test"
                persistent-hint
                thumb-label
                thumb-size="24"
                class="align-center"
                style="width: 100%"
                @change="update"
        >
            <template v-slot:append>
                <v-text-field
                        :value="value"
                        class="center-text mt-0 pt-0"
                        hide-details
                        single-line
                        type="number"
                        style="width: 40px"
                        @change="update"
                ></v-text-field>
            </template>
        </v-slider>
    </div>
</template>

<script>
    export default {
        name: "DynamicListSlider",

        props: {
            value: {
                type: Number,
                required: true
            },
            options: {
                type: Object,
                required: false
            }
        },

        methods: {
            update(value) {

                if (this.options && this.options.min !== undefined && this.options.max !== undefined) {
                    value = Math.max(value, this.options.min);
                    value = Math.min(value, this.options.max);
                }

                this.$emit('input', value)
            },
            stopImmediatePropagation(event) {
                event.stopImmediatePropagation();
            }
        }
    }
</script>

<style>

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none !important;
        margin: 0 !important;
    }

    input[type=number] {
        -moz-appearance: textfield !important;
    }

</style>

<style scoped>
    .center-text >>> input {
        text-align: center;
    }

    div >>> .v-slider__track-fill {
        background-color: rgba(255, 255, 255, 0.2) !important;
    }
</style>
